// ★ logout 시 보존되어야 하는 사용자 데이터 키
export const PERSIST_KEYS_BASE = ['noticePopupExpiresAt', 'userIdsOnDevice', 'qr'] as const
